import useHeroSimulation from './hooks/useHeroSimulation';
import useEraPipeline from './hooks/useEraPipeline';
import Hero from './components/sections/Hero';
import Trusted from './components/sections/Trusted';
import HowItWorks from './components/sections/HowItWorks';
import Categories from './components/sections/Categories';
import AppsGrid from './components/sections/AppsGrid';
import Era from './components/sections/Era';
import Ask from './components/sections/Ask';
import Solutions from './components/sections/Solutions';
import Roi from './components/sections/Roi';
import Quotes from './components/sections/Quotes';
import Power from './components/sections/Power';
import Enterprise from './components/sections/Enterprise';
import FinalCta from './components/sections/FinalCta';
import Reveal from './components/ui/Reveal';
import Seo from './components/Seo';

/** Home page content only — chrome (nav/footer) comes from SiteShell */
export default function LandingPage() {
  
  useHeroSimulation();
  useEraPipeline();

  return (
    <>
      <Seo title="TeamGrid™ | Productivity Tracking, Employee Monitoring, HRMS & CRM Software — One AI Brain" description="See how your company actually works. Productivity tracking, HRMS and CRM in one AI brain that reads patterns, not people. No screenshots, no keystrokes." />
    <main>
      <Hero />
      <Reveal>
        <Trusted />
      </Reveal>
      <Reveal>
        <HowItWorks />
      </Reveal>
      <Reveal>
        <Categories />
      </Reveal>
      <AppsGrid />
      <Reveal>
        <Era />
      </Reveal>
      <Reveal>
        <Ask />
      </Reveal>
      <Solutions />
      <Reveal>
        <Roi />
      </Reveal>
      <Reveal>
        <Quotes />
      </Reveal>
      <Reveal>
        <Power />
      </Reveal>
      <Reveal>
        <Enterprise />
      </Reveal>
      <Reveal>
        <FinalCta />
      </Reveal>
    </main>
  </>
  );
}
